import React, { useState } from "react";
import TeamService from "services/TeamService";
import ImageSelectAndCrop from "components/ImageSelectAndCrop";
import { ReactComponent as AddCamera } from "assets/img/icons/camera.svg";
import { useToasts } from "react-toast-notifications";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import MediaPreview from "components/MediaPreview/MediaPreview";
import { useGlobalContext } from "store/contexts/globalContext";
import { useTeamContext } from "store/contexts/teamContext";
import LazyLoadImage from "components/LazyLoadImage";

export default ({ team, setTeam }) => {
  const { updateTeam } = useGlobalContext();
  const { singleTeam } = useTeamContext();
  const { addToast } = useToasts();
  const [isUpdating, setIsUpdating] = useState(false);
  const uploadingOverlay = {
    height: "104px",
    width: "104px",
    position: "absolute",
    zIndex: "101",
    background: "#000a",
    color: "white",
    fontWeight: "400",
    display: "flex",
    padding: "0px 13px",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  };

  const updateAvatar = async (file) => {
    setIsUpdating(true);

    var name = null;

    try {
      await TeamService.postTeamProfile(team.id, file, name, null);

      addToast("Team profile picture updated successfully.", {
        appearance: "success",
      });
    } catch (error) {
      console.log(error);
    }

    setIsUpdating(false);
    setTeam({
      ...team,
      profile: {
        ...team.profile,
        avatar: URL.createObjectURL(file),
      },
    });

    var teamCopy = { ...singleTeam };
    teamCopy.avatar = URL.createObjectURL(file);
    updateTeam(teamCopy);
  };

  return (
    <React.Fragment>
      <div>
        <MediaPreview attachment={team.profile.avatar} type={"image"}>
          <LazyLoadImage
            image={team.profile.avatar ?? DefaultTeamAvatar}
            key={`${team.profile.name}`}
            alt={"teamImage"}
            imageClassName={"teaminfo-profile-pic f-left"}
            imageWrapperClassName={"teaminfo-profile-pic f-left"}
          />
        </MediaPreview>
        {isUpdating && (
          <div style={uploadingOverlay}>
            <span>Uploading...</span>
          </div>
        )}
      </div>
      {[2].includes(team?.role_id) && (
        <span className="camera-btn">
          <ImageSelectAndCrop onUpdate={updateAvatar} aspect={16 / 9}>
            <AddCamera style={{ width: "25px" }} />
          </ImageSelectAndCrop>
        </span>
      )}
    </React.Fragment>
  );
};
